import { HTMLAttributes } from "react"
import { flexCss } from "../Flex"
import { styled, StyleProps } from "../styles"

const Group = styled.div<HTMLAttributes<HTMLDivElement>>((props: StyleProps) => ({
  ...flexCss,
  flexDirection: `column`,
  marginBottom: props.theme.spacing(5),
  "& > *:not(:last-child)": {
    marginBottom: props.theme.spacing(5),
  },
}))

Group.displayName = `InputGroup.Group`

export { Group }
